
import { Component, Vue } from 'vue-property-decorator';
import { Mutation, Action, State } from 'vuex-class';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import Stepper from '@/components/stepper/index.vue';
import Price from '@/components/price/index.vue';
import { readCookie } from '@/tools/tools';
import Regular from '@/components/regular/index.vue';
import * as _ from 'lodash';
import {
  cardList,
  updateCard,
  deleteCard,
  productNaturePrice,
  checkCart,
  pageVisit,
  getDataCard,
  auto_receive_coupon
} from '@/services/http';

@Component({
  components: {
    Header,
    Footer,
    Stepper,
    Price,
    Regular
  }
})
export default class extends Vue {
    shoppingList: any[] = []

    // 购物车明细列表
    priceDetailObject: any = {
      realTotalPrice: 0,
      totalPrice: 0,
      totalDiscountPrice: 0,
      discountPrice: 0,
      couponPrice: 0,
      integralPrice: 0,
      freightPrice: 0
    }

    dialogVisible: boolean = false

    checkedStaut: boolean = false

    val: number = 1 // 所选商品数量

    naturelist: any[] = [] // 规格列表

    priceList: any[] = [] // 价格列表

    // 所选规格列表
    selectArr: any[] = []

    staus: boolean = true

    loading: boolean = false

    // 购物车数量
    cardListNum: number = 0

    // 编辑选择id
    selectId: string = ''

    isDropDown: boolean = false

    // 判断路由是否第一次进入
    isFirstEnter: boolean = false

    @Mutation('order/CONFIRMORDER') CONFIRMORDER!: Function

    @Action('card/setCardNum') setCardNum!: Function

    @Mutation('card/SETCARDLIST') SETCARDLIST!: Function

    @State('white') whiteState: any

    @Action('white/setWhiteStauts') setWhiteStauts!: Function

    created() {
      this.isFirstEnter = true;
      this.getShoppingCard();
      this.pageVisit();
      this.setCardNum();
    }

    get cardNum(): number {
      return this.shoppingList.filter((e) => e.checked === 1 && !e.closed).length;
    }

    // 总金额计算
    get totalPrice(): number {
      let totalSum = 0;
      this.shoppingList.forEach((item) => {
        if (item.realDiscountStatus) {
          totalSum += _.multiply(item.realDiscountPrice, item.num);
        } else if (item.checked === 1 && !item.closed) {
          totalSum += _.multiply(item.price, item.num);
        }
      });
      return _.round(totalSum, 2);
    }

    // 到详情页面
    godetails(item: any) {
      this.SETCARDLIST([item]);
      this.$router.push(
        `/details?id=${item.productId}&productPriceId=${item.productPriceId}&tag=card`
      );
    }

    handTips() {
      (this as any).$refs.RegularRef.dialogVisible = true;
    }

    async handChange(isChecked: boolean) {
      this.loading = true;
      const selectableRows = this.shoppingList.filter((row) => !row.closed);
      const selection = isChecked ? [...selectableRows] : [];
      await this.handleChange(selection);
      this.loading = false;
    }

    private async fetchPriceDetail() {
      await this.setWhiteStauts();
      this.priceDetailObject = this.whiteState.whiteStauts;
    }

    private updateCheckedStatus() {
      const selectableRows = this.shoppingList.filter((row) => !row.closed);
      this.checkedStaut = selectableRows.length > 0 && selectableRows.every((row) => row.checked === 1);
    }

    // 获取商品规格价格
    private async getNaturePrice(productId: string) {
      const res: any = await productNaturePrice({
        productId,
        companyId: 1
      });
      this.naturelist = res.data.data.nature;
      this.priceList = res.data.data.price;
      const arr = this.shoppingList.filter((value) => value.productId === productId)[0].natureList;
      arr.forEach((value: any, index: number) => {
        this.$set(value, 'index', index);
      });
      this.selectArr = JSON.parse(JSON.stringify(arr));
    }

    // 获取购物车列表数据
    private async getShoppingCard() {
      this.loading = true;
      const anchor = readCookie('anchor');
      const res: any = await cardList({
        src: anchor ? (anchor.src ? anchor.src : 2) : 4,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        companyId: 1
      });

      if (res.data.code === 100) {
        this.cardListNum = res.data.data.num;
        const closeArr = res.data.data.closedList;
        closeArr.forEach((value: any) => {
          this.$set(value, 'closed', true);
          this.$set(value, 'checked', 0);
        });
        this.shoppingList = [...res.data.data.list, ...closeArr];
        this.$nextTick(async () => {
          this.shoppingList.forEach((row) => {
            this.$set(row, 'totalPrice', _.round(_.multiply(row.price, row.num), 2));

            if (row.checked === 1) {
              const { multipleTable } = this.$refs;
              (multipleTable as any).toggleRowSelection(row, true);
            }
          });

          this.updateCheckedStatus();
          await this.fetchPriceDetail();
          this.loading = false;
        });

        getDataCard({
          cartNum: this.cardListNum,
          src: anchor ? (anchor.src ? anchor.src : 2) : 4,
          equip: anchor ? anchor.equip : 4,
          version: anchor ? anchor.version : '',
          model: anchor ? anchor.model : '',
          equipVersion: anchor ? anchor.equipVersion : '',
          equipMeid: anchor ? anchor.equipMeid : '',
          eventNo: this.isFirstEnter ? '2.2.0.0.0.0.1' : '2.2.0.0.0.0.2',
          companyId: 1
        });
        this.isFirstEnter = false;
      }
    }

    selectable(row: any) {
      return !row.closed;
    }

    // 编辑更新购物车
    private async updateShopping(obj: any, index: number) {
      this.loading = true;
      const { id, productPriceId, num } = obj;
      const res: any = await updateCard({
        id,
        num,
        checked: this.shoppingList[index].checked,
        productPriceId,
        companyId: 1
      });
      if (res.data.code === 100) {
        this.getShoppingCard();
      }
      this.loading = false;
      await this.fetchPriceDetail();
    }

    async selectSingle(selection: any, row: any) {
      const isSelected = selection.some((item: any) => item.id === row.id);
      this.$set(row, 'checked', isSelected ? 1 : 0);

      // 在后台同步勾选状态
      try {
        await updateCard({
          id: row.id,
          num: row.num,
          checked: row.checked,
          productPriceId: row.productPriceId,
          companyId: 1
        });
      } catch (error) {
        console.error('同步单个勾选状态失败', error);
      }

      // 立即获取更新列表数据最新的合计金额
      await this.getShoppingCard();
    }

    // 勾选购物车
    private async handleChange(selection: any) {
      const isSelectAll = selection.length > 0
            && selection.length === this.shoppingList.filter((row) => !row.closed).length;
      // 1. 更新数据
      this.shoppingList.forEach((row) => {
        if (!row.closed) {
          this.$set(row, 'checked', isSelectAll ? 1 : 0);
        }
      });
      // 2. 同步表格UI勾选状态
      this.$nextTick(() => {
        const { multipleTable } = this.$refs as any;
        this.shoppingList.forEach((row) => {
          if (!row.closed) {
            multipleTable.toggleRowSelection(row, isSelectAll);
          }
        });
      });
      // 3. 后台批量同步勾选状态
      const ids = this.shoppingList
        .filter((value: any) => !value.closed)
        .map((value: any) => value.id)
        .join(',');
      if (ids) {
        try {
          await checkCart({
            ids,
            checked: isSelectAll ? 1 : 0,
            companyId: 1
          });
        } catch (error) {
          console.error('同步全选状态失败', error);
        }
      }
      // 4. 只刷新价格明细
      await this.getShoppingCard();
      this.checkedStaut = isSelectAll;
    }

    // 去结算
    private async toSettleMent() {
      // 自动领取优惠卷
      if (!this.priceDetailObject.receiveCoupon) {
        const productIds = this.shoppingList
          .filter((e) => e.checked === 1)
          .map((e) => e.productId)
          .join(',');
        if (productIds) {
          await auto_receive_coupon({ productIds, companyId: 1 });
        }
      }

      if (
        this.shoppingList.filter((e) => e.checked === 1).length !== 0
            && Number(this.priceDetailObject.totalPrice) <= 100000
      ) {
        const confirmlist = this.shoppingList.filter((e) => e.checked === 1);
        confirmlist.forEach((row) => {
          this.$set(row, 'totalPrice', _.round(_.multiply(row.price, row.num), 2));
        });
        this.CONFIRMORDER(confirmlist);
        this.$router.push('/orderconfirm?type=1&from=card');
      }
    }

    selectNature(obj: any, index: number) {
      const { id, natureValue, natureName } = obj;
      this.selectArr.forEach((value, indexs) => {
        if (value.index === index) {
          this.selectArr[indexs].id = id;
          this.selectArr[indexs].natureValue = natureValue;
          this.selectArr[indexs].natureName = natureName;
        }
      });
      const price = this.priceList.filter(
        (e: any) => e.natureIds.split(',').sort().join(',')
                === this.selectArr
                  .map((ele: any) => ele.id)
                  .sort()
                  .join(',')
      );
      this.selectId = price[0].id;
    }

    // 没有所属规格置灰
    private checkDisabled(id: number, index: number) {
      let flagCheck = false;
      const naturearrCheck = this.priceList.map((e: any) => e.natureIds.split(','));
      if (this.selectArr.length > 0) {
        naturearrCheck.forEach((_item) => {
          let flagSum = 0;
          const lines: any[] = [];
          this.selectArr.forEach((item) => {
            lines.push(item.index);
            if (_item.indexOf(`${item.id}`) !== -1) {
              flagSum += 1;
            }
          });
          if (_item.indexOf(`${id}`) !== -1 && flagSum >= 1) {
            if (
              (flagSum >= this.selectArr.length - 1 && lines.indexOf(index) !== -1)
                        || flagSum >= this.selectArr.length
            ) {
              flagCheck = true;
            }
          }
        });
        if (flagCheck || (this.selectArr.length === 1 && index === this.selectArr[0].index)) {
          return false;
        }

        return true;
      }
      return false;
    }

    //  确定更新商品规格
    async confirmList(item: any, status: string) {
      if (status === 'confirm') {
        if (this.selectId && this.selectId !== item.productPriceId) {
          const res: any = await updateCard({
            id: item.id,
            num: item.num,
            checked: item.checked,
            productPriceId: this.selectId,
            companyId: 1
          });
          if (res.data.code === 100) {
            this.getShoppingCard();
          }
        }
      }
      (this.$refs[`dropdown${item.id}`] as any).visible = false;
    }

    // 删除选中购物车
    deleteCard() {
      if (this.shoppingList.filter((e) => e.checked === 1 && !e.closed).length === 0) {
        this.$message.error('请先勾选');
      } else {
        const $this = this;
        const arr = this.shoppingList.filter((e) => e.checked === 1 && !e.closed);
        const ids = arr.map((value) => value.id).join(',');
        this.$confirm('确定删除已选中商品？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(async () => {
            const res: any = await deleteCard({
              ids
            });
            if (res.data.code === 100) {
              $this.setCardNum();
              $this.getShoppingCard();
              this.$message.success('删除成功!');
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(() => { });
      }
    }

    // 删除已下架
    deleteSingle(ids: string) {
      const $this = this;
      this.$confirm('确定删除已选中商品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const res: any = await deleteCard({
            ids
          });
          if (res.data.code === 100) {
            $this.setCardNum();
            $this.getShoppingCard();
            this.$message.success('删除成功!');
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => { });
    }

    // 访问页面数据埋点
    private pageVisit() {
      const anchor = readCookie('anchor');
      pageVisit({
        pageType: 2,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? (anchor.src ? anchor.src : 2) : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
    }
}
